import { ReactElement, useContext, useEffect, useMemo, useState } from 'react';
import { StoresContext } from '../App';
import { Store } from '../types';

export interface RenderProps {
    page: number;
    setPage: (p: number) => void;
    total: number;
    stores: Store[];
    pageSize: number;
}

type RenderComponent = (props: RenderProps) => ReactElement;

export default function StoreCards({
    render,
    pageSize = 20,
}: {
    render: RenderComponent;
    pageSize?: number;
}) {
    const { stores } = useContext(StoresContext);
    const [page, setPage] = useState(1);
    const visibleStores = useMemo(() => {
        return stores.slice((page - 1) * pageSize, page * pageSize);
    }, [stores, page, pageSize]);
    useEffect(() => {
        setPage(1);
    }, [stores]);
    const Render = render;

    return (
        <Render
            page={page}
            setPage={setPage}
            total={stores.length}
            stores={visibleStores}
            pageSize={pageSize}
        />
    );
}
